
import { BiStoreAlt } from "react-icons/bi";
import ThinCategoryCard from "../../../../../components/cards/thin-card";
import textUtils from "../../../../../utils/textUtils";
import { BasicCardWrapper, GestaoConveniadosContainer } from "../../../cardDescontos/style";
import { partnerContent } from "./content";
import { PartnerSealContainer } from "./styles";

export const Partners = () => {
  const { partner_summary } = partnerContent;

  return (
    <div>
      <GestaoConveniadosContainer>
        <div>
          <span style={{ display: "flex", gap: "0.5rem" }}>
            <h3>{textUtils.handleTextHigliht(partner_summary.title)}</h3>
            <BiStoreAlt size={28} color="#ff9c00"></BiStoreAlt>
          </span>{" "}
            
          <BasicCardWrapper>
            {partner_summary.categories.map((category, index) => {
              return (
                <ThinCategoryCard
                  nome={category.name}
                  imagem={category.img}
                  id={index}
                  key={index}
                  routePrefix="parceiros/categoria"
                />
              );
            })}
          </BasicCardWrapper>
        </div>
      </GestaoConveniadosContainer>
      <PartnerSealContainer>
        <img src={partnerContent.affiliate_seal} alt="" />
        <p>
          {textUtils.handleTextHigliht(
            partnerContent.affiliate_seal_description,
            `bold`
          )}
        </p>
      </PartnerSealContainer>
    </div>
  );
};
